import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import EUserEnum from "@/struct/user/EUserEnum";
import ApiAppVersions from "@/api/ApiAppVersions";
import { Getter } from "vuex-class";
let AppVersionUpdates = class AppVersionUpdates extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Главная",
                disabled: false
            },
            {
                to: "/secure/admin/app-version-updates",
                text: "Управление обновлениями приложений",
                disabled: false,
            },
            {
                to: "",
                text: "История подтверждений",
                disabled: true
            }
        ];
        this.TableHeaders = [
            {
                text: "Пользователь",
                value: "customer_uuid",
            },
            {
                text: "Дата подтверждения",
                value: "created_at",
            }
        ];
        this.CurrentVersionUUID = "";
        this.TableItems = [];
    }
    CanAddAndEditAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin ||
                this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Editor));
    }
    CanDeleteAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin));
    }
    async getAppVersions() {
        try {
            this.TableItems = await ApiAppVersions.GetAppConfirmationHistory(ApiEnter.CurrentSessionUUID, this.CurrentVersionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    ValidateBoolean(value) {
        return value ? "Да" : "Нет";
    }
    mounted() {
        this.CurrentVersionUUID = this.$route.params.uuid;
        this.getAppVersions();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], AppVersionUpdates.prototype, "GetCurrentSessionUser", void 0);
AppVersionUpdates = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], AppVersionUpdates);
export default AppVersionUpdates;
